<template>
    <div>
        <ol class="breadcrumb pull-right">
			<li class="breadcrumb-item"><a href="javascript:;">Home</a></li>
			<li class="breadcrumb-item active">User Management</li>
		</ol>

        <h1 class="page-header">User Management</h1>
        <hr>

         <panel class="border border-secondary" :noExpand="true">
            <template slot="header">
                <h4 class="panel-title">Filter Option</h4>
            </template>
            <div class="row pr-2 pl-2">
            <div class="col-lg-4 ">
                <div class="form-group row">
                    <label for="staticEmail" class="col-sm-3 col-form-label">User Type</label>
                    <div class="col-sm-9">
                        <select class="form-control" style="width:100%" v-model="managementType">
                            <option value="dashboard" selected>Dashboard User</option>
                            <option value="mobile">Mobile User</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 ">
                <div class="form-group row">
                    <label for="staticEmail" class="col-sm-3 col-form-label">Search Name</label>
                    <div class="col-sm-9">
                        <input class="form-control" @input="debounceInput"/>
                    </div>
                </div>
            </div>
        </div>
        </panel>

        <UserList :managementType="managementType" :name="name"></UserList>
    </div> 
</template>

<script>
import UserList from './childComponents/UserList'
import debounce from 'debounce'

export default {
    data(){
        return {
            managementType : 'dashboard',
            name : ''
        }
    },
    components : {
        UserList,
    },
    methods : {
        debounceInput: debounce(function (e) {
            // this.$store.dispatch('updateInput', e.target.value)
            this.name = e.target.value
        }, 2000)
    }
}
</script>